<template>
    <div>
        <div class="d-flex-center py-5">
            <img
                src="@/assets/report/weekly.png">
        </div>
        <v-container>
            <v-row>
                <v-col
                    class="d-flex-center pb-0"
                    offset="4"
                    cols="4">
                    <div class="weekly-report-input">
                        <v-menu
                            v-model="datePickerShow"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="dateFormatted"
                                        label="Weekly"
                                        prepend-inner-icon="event"
                                        @click:prepend-inner="datePickerShow = true"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                :locale="localeLang"
                                :max="maxDate"
                                :allowed-dates="allowOnlyMondan"
                                v-model="datePick"
                                @input="datePickerShow = false">
                            </v-date-picker>
                        </v-menu>
                    </div>
                </v-col>

                <v-col
                    class="d-flex-center pt-0"
                    offset="4"
                    cols="4">
                    <v-btn
                        color="primary"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="genWeeklyReport">
                        export
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Weekly',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            datePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            datePick: null,
            maxDate: this.$util.getCurrentDate()
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        }
    },

    methods: {
        allowOnlyMondan (val) {
            const day = new Date(Date.parse(val)).getDay()
            return day === 1
        },

        async genWeeklyReport () {
            this.$store.dispatch('setLoading', true)
            this.axios.post('report/weekly', { date: this.datePick, branch_id: this.branchId }, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            }).then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                this.$store.dispatch('setLoading', false)
                window.open(url)
            }).catch((error) => {
                this.error = error
            })
        }
    },

    mounted () {
        const prevMonday = new Date()
        prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7)
        this.datePick = new Date(prevMonday).toISOString().substr(0, 10)
    },

    watch: {
        'datePick' () {
            this.dateFormatted = this.$util.formatDate(this.datePick)
        }
    }
}
</script>

<style lang="scss" scoped>
.space-between {
    display: flex;
    justify-content: space-between;
}
</style>
